export function buildControls() {
    var data = {
        normalAction: 'innerPencil',
        shiftAction: 'outerPencil',
        altAction: 'answer',
        showBasicControls: true,
        showSidebar: true,
        confirmReset: false,
        showRightMenu: false,
        showVictory: false,
        itemIcon: '',
        itemMessage: '',
        itemDialog: false,
        showIntro: true
    }

    return data;
}

export function setControlFunctions(data) {
    data.showIntro = true;
    data.showItemDialog = function(icon, message) {
        data.itemDialog = true;
        data.itemIcon = icon;
        data.itemMessage = message;
    }
}